import React from "react";
import Transaction_Form from "./Transaction_Form";
import {connect} from "react-redux";
import {Add_Transaction_With_Firebase} from "../../actions/Transaction";

class Add_Transaction_Page extends React.Component {
    onSubmit = (transaction) => {
        this.props.Add_Transaction_With_Firebase(transaction);
    };

    render() {
        return (
            <div>
                <Transaction_Form
                    onSubmit = {this.onSubmit}
                    button_name="Add Transaction"
                    form_name="Add Transaction"
                />
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
   Add_Transaction_With_Firebase: (transaction) => dispatch(Add_Transaction_With_Firebase(transaction))
});

export default connect(undefined, mapDispatchToProps)(Add_Transaction_Page);